@if (isSending) {
    <button mat-icon-button disabled class="horizontal-menu-element">
        <mat-icon class="rotating-icon-counterclockwise">cached</mat-icon>
    </button>
} @else {
    <button mat-icon-button [matMenuTriggerFor]="$any(menu)" (click)="preventSelection($event)"
            [disabled]="params.context?.readOnlyTable"
            [class.tw-opacity-30]="params.context?.readOnlyTable"
            aria-label="Example icon-button with a menu"
            class="horizontal-menu-element">
        <mat-icon>more_horiz</mat-icon>
    </button>
}
<mat-menu #menu="matMenu">
    @if(isSalesDataSentSection) {
        <div [matTooltip]="!canSendPms ? ('HISTORY.SALES_DATA_SENT.MESSAGES.SEND_PMS_DISABLED_TOOLTIP' | translate) : ''">
            <button mat-menu-item [disabled]="!canSendPms"
                (click)="onSendPms($event)">
                @if(hasSalesDataSent) {
                    <span translate="HISTORY.SALES_DATA_SENT.SHOWCASE.ACTIONS.SEND_PMS_WITH_SALES_DATA_SENT"></span>
                } @else {
                    <span translate="HISTORY.SALES_DATA_SENT.SHOWCASE.ACTIONS.SEND_PMS_WITHOUT_SALES_DATA_SENT"></span>
                }
            </button>
        </div>
        @if(canShowJson) {
            <button mat-menu-item (click)="onShowJson($event)">
                <span translate="HISTORY.SALES_DATA_SENT.SHOWCASE.ACTIONS.SHOW_JSON"></span>
            </button>
        }
    }
    @else if(isSaleSection) {
        <button mat-menu-item (click)="onOpenDetail($event)">
            <span translate="HISTORY.SALES.SHOWCASE.ACTIONS.DETAIL"></span>
        </button>
        @if(!isCreditNote) {
            <button mat-menu-item (click)="onRefundVoid($event)">
                @if(isEInvoice) {
                    <span translate="HISTORY.SALES.SHOWCASE.ACTIONS.CREDIT_NOTE"></span>
                } @else {
                    <span translate="HISTORY.SALES.SHOWCASE.ACTIONS.CANCEL"></span>
                }
            </button>
            <button mat-menu-item (click)="onRestoreSale($event)">
                <span translate="HISTORY.SALES.SHOWCASE.ACTIONS.RESTORE_SALE"></span>
            </button>
        }
        @if(!isEInvoice) {
            <button mat-menu-item (click)="onCourtesyReceipt($event)"> <!-- TODO : Print in progress? -->
                <span translate="HISTORY.SALES.SHOWCASE.ACTIONS.COURTESY_RECEIPT"></span>
            </button>
        }
        @if(!isCreditNote) {
            <button mat-menu-item (click)="onDuplicateSale($event)">
                <span translate="HISTORY.SALES.SHOWCASE.ACTIONS.DUPLICATE_SALE"></span>
            </button>
        }
    
        @if(canUseExpenseReport) {
            <button mat-menu-item (click)="onCreateExpenseReport($event)">
                <span translate="HISTORY.EXPENSE_REPORT.TITLE"></span>
            </button>
        }
    }
    @else if(isEInvoiceSection) {
        @switch (eInvoicesStatus) {
            @case ('error') {
                <button mat-menu-item (click)="sendEInvoice($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.SEND_E_INVOICE_IN_ERROR"></span>
                </button>
                <button mat-menu-item (click)="editCustomer($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.EDIT_CUSTOMER"></span>
                </button>
                <button mat-menu-item (click)="editInvoiceOptions($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.EDIT_INVOICE_OPTIONS"></span>
                </button>
                <button mat-menu-item (click)="openHelpMessage($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.OPEN_HELP_MESSAGE"></span>
                </button>
            }

            @case ('pending') {
                <button mat-menu-item (click)="sendEInvoice($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.SEND_PENDING_E_INVOICE"></span>
                </button>
                <button mat-menu-item (click)="editCustomer($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.EDIT_CUSTOMER"></span>
                </button>
            }

            @case ('sent') {
                <button mat-menu-item (click)="openHelpMessage($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.OPEN_HELP_MESSAGE"></span>
                </button>
            }

            @case ('delivered') {
                <button mat-menu-item (click)="sendViaEmailEInvoice($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.SEND_VIA_EMAIL_E_INVOICE"></span>
                </button>
                <button mat-menu-item (click)="openHelpMessage($event)">
                    <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.OPEN_HELP_MESSAGE"></span>
                </button>
            }

            @case ('downloaded') {
            }
        }

        <button mat-menu-item (click)="duplicateSale($event)">
            <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.DUPLICATE_SALE"></span>
        </button>

        @if(canEditState) {
            <button mat-menu-item (click)="changeSaleStatus($event)">
                <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.CHANGE_SALE_STATUS"></span>
            </button>
        }

        <button mat-menu-item (click)="downloadEInvoice($event)">
            <span translate="HISTORY.E_INVOICE.SHOWCASE.ACTIONS.DOWNLOAD_E_INVOICE"></span>
        </button>
    }
</mat-menu>